import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment/moment';
import { Http } from '@angular/http';
import {CsvService} from 'angular2-json2csv';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DialogService,DialogComponent} from 'ng2-bootstrap-modal';
import {AlertHistoryComponent} from '../alert-history/alert-history.component';
import { Popup } from 'ng2-opd-popup';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-three-time-or-more-postponement-report',
  templateUrl: './three-time-or-more-postponement-report.component.html',
  styleUrls: ['./three-time-or-more-postponement-report.component.scss']
})
export class ThreeTimeOrMorePostponementReportComponent implements OnInit {
	finalArr=[];
	listContractLevel=[];
	ListbranchDetails:any[]=[];
	ListAllHistroyDetails=[];
	techinicianDetails=[]
	AllMakedetails=[];
	AllModalDetails=[];
	ListTechnicianName=[];
	fromDate:any;
	toDate:any;
  	listSearchData:any[] = [];
  	Response:any[] = [];
  	ArrCount:any;
  	ListOfCustomerMaster:any[] = [];
  	customerDetails:any[] = [];
  	ListReportDetails:any[]=[];
  	CustomerName:any;
  	histroyPP:any[] = [];
  	histroy:any[]=[];
  	clientName:any;
  	serialNumber:any;
  	mcLocation:any;
  	phoneNumber:any;
  	email:any;
  	make:any;
  	model:any;
  	hmrHours:any;
  	technicianName:any;
  	lastServiceType:any;
  	lastServiceHours:any;
  	yearOfManufacture:any;
  	branch:any;
  	serviceContractOfferedYear:any;
  	contractReference:any;
  	noofServiceContractYears:any;
  	startDate:any;
  	endDate:any;
  	noOfservice:any;
  	serviceRemainderDays:any;
  	currentService:any;
  	ListserviceDetails:any;
  	ServiceType;
  	@ViewChild('postPonedHistroy') postPonedHistroy: Popup;
  	@ViewChild('Histroy') Histroy: Popup;
  	startingCount:number = 0;
	endingCount:number = 0;
	p: number = 1;
	ListAllServcieType =[];
	ServiceContractExtend=[];
	histroyPr = [];
	orgId:number;
  	userId:number; 
  	loading:boolean=false;
	constructor(private dialogservice:DialogService,private http: Http,private csvService: CsvService,private router:Router,private route : ActivatedRoute) { }

	ngOnInit() {
		this.loading=true
		if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	      window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
	      this.orgId=this.route.params['value'].orgId;
	      this.userId=this.route.params['value'].userId;
	      console.log('OrgId '+ this.orgId);
	      console.log('UserId '+ this.userId);
	    }
	    var date = new Date(), y = date.getFullYear(), m = date.getMonth();
		let firstDay = new Date(y, m, 1);
		let lastDay = new Date(y, m + 1, 0);
		let firstDate = moment(firstDay).format('YYYY-MM-DD');
		let lastDate = moment(lastDay).format('YYYY-MM-DD');
		this.fromDate = moment(firstDay).format('YYYY-MM-DD');
		this.toDate = moment(lastDay).format('YYYY-MM-DD');
		this.getAllDetailsFromCustomerMaster ();
		this.getAllServiceTypeDetails();
		this.search();
		this.getTechnicianName();
		this.getBranchDetails();
	//	this.getmodeldetails();
		this.getmakedetailsforhistory();
		this.getmodeldetailsforhistory();
		
	}

	getCount(){
     if(this.p < Math.ceil(this.ListReportDetails.length/10)){
       this.startingCount = (this.p-1)*10;
       if(this.startingCount == 0){
         this.startingCount = 1;
       }
       this.endingCount = this.p*10;
     } else if(this.p == Math.ceil(this.ListReportDetails.length/10)){
       let count = this.ListReportDetails.length%10;
       this.startingCount = (this.p-1)*10;
       this.endingCount = this.startingCount + count;
       if(this.startingCount == 0){
         this.startingCount = 1;
         this.endingCount = count;
       }
     }
  }



	getBranchDetails(){
		let obj={
		 'orgId':this.orgId
		}
		return this.http.post('/api/getbranchdetails',obj).subscribe(res=>{
			 this.ListbranchDetails=res.json();
		})
	 }

	getTechnicianName() {
		let techObj = {
			'orgId':this.orgId
			}
	return this.http.post('/api/getTechniciansName', techObj).subscribe(
		res => {
				// res.json();
			this.ListTechnicianName = res.json();
				let technicianArr = []
				for(var i=0;i<this.ListTechnicianName.length;i++) {
					let obj = {
						'label':this.ListTechnicianName[i].FIRST_NAME +' '+ this.ListTechnicianName[i].LAST_NAME,
						'value':this.ListTechnicianName[i].ID
					}
					technicianArr.push(obj);
				}
				this.techinicianDetails = technicianArr;
	},(err)=>{
		this.loading=false;
	})
}
getmakedetailsforhistory() {
  
	let makeObj = {
		'orgId':this.orgId
	}
	return this.http.post('/api/getMakedetails', makeObj).subscribe(
	 res => {
		
		 this.AllMakedetails=[];
		 let response = res.json();
		 if(response.length>0) {
			 this.AllMakedetails = response;
			 
		 }
	 },(err)=>{
		 this.loading=false;
		// this.spinner.hide();
	 })
}

getmodeldetailsforhistory() {
	// this.loading=true;
		 let modelObj = {
			 'orgId':this.orgId
		 }
		 return this.http.post('/api/getModelDetails', modelObj).subscribe(
			res => {
				 
				this.AllModalDetails = [];
				let response = res.json();
				if(response.length>0) {
					this.AllModalDetails =response;
					//this.model = response[0].model.toUpperCase();;
				}
			},(err)=>{
				this.loading=false;
			//	this.spinner.hide();
			})
	 }

	exportToExcel(event) {
		// let Reportstartdate = moment(this.fromDate).format('D MMM YYYY');
		// let Reportenddate = moment(this.toDate).format('D MMM YYYY');
		// this.csvService.download(this.ListReportDetails,Reportstartdate +'to'+Reportenddate+ 'Postpone Report');

		let	data=[];
		let Reportstartdate = moment(this.fromDate).format('D MMM YYYY');
		let Reportenddate = moment(this.toDate).format('D MMM YYYY');
		let title=Reportstartdate+' '+'to'+' '+ Reportenddate+' '+'Postpone Report.xlsx'
		data.push([Reportstartdate+' '+'to'+' '+ Reportenddate+' '+'Postpone Report'])
		data.push([])
		data.push(['S NO','CLIENT NAME','SERIAL NUMBER','LOCATION',"SERVICE TYPE",'START DATE','END DATE','SERVICE DATE','CURRENT SERVICE','CONTRACT LEVEL'])
		for(let i=0;i<this.ListReportDetails.length;i++) {
			data.push([i+1,this.ListReportDetails[i].clientName,this.ListReportDetails[i].mcserialNum,this.ListReportDetails[i].location,this.ListReportDetails[i].ServiceType,this.ListReportDetails[i].startdate,this.ListReportDetails[i].enddate,this.ListReportDetails[i].lastServiceDate,this.ListReportDetails[i].noOfServiceUsed,this.ListReportDetails[i].contractLevel])
		}
		let wb: XLSX.WorkBook =XLSX.utils.book_new();
		const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);

		XLSX.utils.book_append_sheet(wb, ws,'Postpone Report');
		XLSX.writeFile(wb,title);
	}

	showAlert(){
		console.log("ListAllHistroyDetails",this.ListAllHistroyDetails)
		this.dialogservice.addDialog(AlertHistoryComponent,{title:'View History',values:this.ListAllHistroyDetails,contractlevelArr:this.listContractLevel,'finalArr':this.finalArr,'customIndex':0})
			

	    // this.dialogservice.addDialog(AlertHistoryComponent,{title:'View History',clientName:this.clientName,
	    //   HMRHours:this.hmrHours,ContractReference:this.contractReference,
	    //   SerialNumber:this.serialNumber,TechnicianName:this.technicianName,NoOfServiceContractYears:this.noofServiceContractYears
	    //   ,MCLocation:this.mcLocation,LastSerivceType:this.lastServiceType,StartDate:this.startDate,PhoneNumber:this.phoneNumber
	    //   ,LastServiceHours:this.lastServiceHours,EndDate:this.endDate,
	    //   Email:this.email,YearOfManufacture:this.yearOfManufacture,noOfservice:this.noOfservice,
	    //   Make:this.make,Branch:this.branch,ServiceRemainderDay:this.serviceRemainderDays,Modal:this.model,
	    //   ServiceContractOfferedYear:this.serviceContractOfferedYear,
	    //   currentService:this.currentService,histroyPP:this.histroyPP,ListserviceDetails:this.ListserviceDetails,histroyPr:this.histroyPr
	    //   ,ServiceContractExtend:this.ServiceContractExtend});
	    // this.dialogservice.addDialog(AlertHistoryComponent,{title:this.Getmessage,message:"adasSSSSSSSSS"})
	  }

	todatechange(date) {
    	if(date < this.fromDate) {
    		alert('To date should be greater than From Date');
    		this.toDate = '';
    	}
    }

	getAllDetailsFromCustomerMaster () {
		let CustomerObj ={
			'orgId':this.orgId
		}
  		return this.http.post('/api/getCustomerMasterDetails', CustomerObj).subscribe(
     	res => {
     		 
     		this.ListOfCustomerMaster = res.json();
     		for(var i=0;i<this.ListOfCustomerMaster.length;i++) {
     			let obj = {
     				'Id':this.ListOfCustomerMaster[i]._id,
     				'Name':this.ListOfCustomerMaster[i].customer_Name
     			}
     			this.customerDetails.push(obj);
				 }
				 //this.loading=false
      	},(err)=>{
      		this.loading=false;
      	})
  	}

  	close() {
      this.postPonedHistroy.hide();
      this.Histroy.hide();
    }

    getAllServiceTypeDetails() {
			//this.loading=true
    	let serviceObj ={
			'orgId':this.orgId
		}
	    return this.http.post('/api/getServiceTypedetails', serviceObj).subscribe(
        res => {
					 this.ListAllServcieType = res.json();
					 //this.loading=false
        },(err)=>{
					this.loading=false
       		alert('unable to load make values')
        })
	}

	search() {
		
		if(this.fromDate == "" || this.fromDate == null || this.fromDate == undefined) {
			this.loading=false;
			alert('please select the From Date');
		} else if(this.toDate == "" || this.toDate == null || this.toDate == undefined) {
			this.loading=false;
			alert('please select the To Date');
		} else {
			let RequiredObj = {
		      'fromDate': moment(this.fromDate).format('YYYY-MM-DD'),
		      'toDate':moment(this.toDate).add(1, 'days').format('YYYY-MM-DD'),
		      'orgId':this.orgId
		    }

		    return this.http.post('/api/getPostPonedReportdetails', RequiredObj).subscribe(
		    res=>{ 
		   
				let SerialNumber = [];
			    let UniqueSN = [];
			    this.Response = res.json();
			    console.log('getPostPonedReportdetails ' + this.Response);
			    for(let i=0;i<this.Response.length;i++) {
			    	if(this.Response[i].status == 0 && this.Response[i].type == 'servicePostpone') {
			    		SerialNumber.push(this.Response[i].serialNumber);
			    	}
			    }
			    
			    UniqueSN = SerialNumber.filter(function(item, i, ar){ 
			    	return ar.indexOf(item) === i; });
			    let FinalArr = [];
			    for(var i=0;i<UniqueSN.length;i++) {
			    	let count=0;
			    	for(var k=0;k<SerialNumber.length;k++) {
			    		if(UniqueSN[i] == SerialNumber[k]) {
			    			count++;
			    			if(count>=3) {
			    				FinalArr.push(UniqueSN[i]);
			    			}
			    		}
			    	}
			    }
			    console.log("FinalArr "+FinalArr);
			    let ReqObj = {
			    	'data':FinalArr
			    }
			    return this.http.post('/api/getPostPonedReportBasedOnSerialNumber', ReqObj).subscribe(
		    	res=>{ 

		    		this.ListReportDetails = [];
		    		let ResponsePP = res.json();
		    		console.log('getPostPonedReportBasedOnSerialNumber ' + ResponsePP);
		    		for(var i=0;i<ResponsePP.length;i++) {
		    			for(var k =0;k<this.customerDetails.length;k++) {
				      		if( ResponsePP[i].client_Name == this.customerDetails[k].Id){
				      			this.CustomerName = this.customerDetails[k].Name
				      		}
				      	}

				      	for(var s=0;s<this.ListAllServcieType.length;s++) {
				      		if(this.ListAllServcieType[s]._id == parseInt(ResponsePP[i].Servicedetails[ResponsePP[i].serviceScheduleDay - 1].service_Type)) {
				      			this.ServiceType = this.ListAllServcieType[s].servicetype;
				      		}
				      	}
				      	let reqObj = {
			    			'clientName':this.CustomerName,
			    			'mcserialNum':ResponsePP[i].serial_Number,
			    			'contractLevel':ResponsePP[i].contractLevel,
							'location':ResponsePP[i].mcLocation,
							'id':ResponsePP[i]._id,
			    			'startdate':moment(ResponsePP[i].start_Date).format("D MMM YYYY"),
			    			'enddate': moment(ResponsePP[i].end_Date).format("D MMM YYYY"),
			    			'lastServiceDate':moment(ResponsePP[i].Servicedetails[ResponsePP[i].serviceScheduleDay-1].date).format("D MMM YYYY"),
			    			'noOfServiceUsed':ResponsePP[i].serviceScheduleDay,
			    			'ServiceType':this.ServiceType.toUpperCase()
			    		}
				    	this.ListReportDetails.push(reqObj);
							
		    		}
		    		this.getCount();
					this.loading=false;
		    	},(err)=>{
		    		this.loading=false;
		    	})
			},(err)=>{
				this.loading=false;
			})//getStatusDuereport end here
		}
	    
	}

	viewHistory(serialNumber, ServiceNum, pmId) {
		let ReqObjValue = {
			'pmId':pmId
		}
		return this.http.post('/api/getHistoryDetailsBasedOnContractLevel', ReqObjValue).subscribe(
    	res=>{ 
				this.histroy = res.json();
				this.ListAllHistroyDetails = [];
				for(let h=0;h<this.histroy.length;h++) {
          for(var k =0;k<this.customerDetails.length;k++) {
              if( this.histroy[0].client_Name == this.customerDetails[k].Id){
                this.clientName = this.customerDetails[k].Name
              }
            }
            //this.extensionUpdateId = this.histroy[h]._id
            for(let m=0;m<this.AllMakedetails.length;m++ ) {
              if(this.AllMakedetails[m]._id == parseInt(this.histroy[h].make)) {
								
                this.make = this.AllMakedetails[m].make;
              }
						}
						
						for(let n=0;n<this.ListbranchDetails.length;n++){
							if(this.ListbranchDetails[n]._id==this.histroy[h].branch){
							 this.histroy[h].branch=this.ListbranchDetails[n].branchAlias
							}
						}

            for(let md=0;md<this.AllModalDetails.length;md++ ) {
              if(this.AllModalDetails[md]._id == parseInt(this.histroy[h].model)) {
                this.model = this.AllModalDetails[md].model;
              }
            }
            for(let t=0;t<this.techinicianDetails.length;t++) {
              if(this.techinicianDetails[t].value == parseInt(this.histroy[h].technician_Name)) {
                this.technicianName = this.techinicianDetails[t].label;
              }
            }
            for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
              if(this.ListAllServcieType[ls]._id == parseInt(this.histroy[h].last_Service_Type)) {
                this.lastServiceType = this.ListAllServcieType[ls].servicetype;
              }
						}
						if((this.lastServiceType==undefined||this.lastServiceType=="")&&this.histroy[h].last_Service_Type=="New Vehicle"){
							this.lastServiceType="New Vehicle"
						 }
            for(let i=0;i<this.histroy[h].Servicedetails.length;i++) {
              for(let k=0;k<this.ListAllServcieType.length;k++) {
                if(parseInt(this.histroy[h].Servicedetails[i].service_Type) == this.ListAllServcieType[k]._id) {
                  this.histroy[h].Servicedetails[i].service_Type = this.ListAllServcieType[k].servicetype;
                }
              }
              
            }
            let histroyObject = {
			  'clientName':this.clientName,
			  'pmId':this.histroy[h]._id,
              'serialNumber':this.histroy[h].serial_Number,
              'mcLocation':this.histroy[h].mcLocation,
              'phoneNumber':this.histroy[h].phone_Number,
              'email':this.histroy[h].email,
              'make':this.make,
              'modal':this.model,
              'hmr':this.histroy[h].hmr,
              'contractLevel':this.histroy[h].contractLevel,
              'technicianName':this.technicianName,
              'lastserviceType':this.lastServiceType,
              'lastServiceHours':this.histroy[h].last_Service_Hours,
              'yearOfManufacturer':this.histroy[h].year_Of_manufacturer,
              'branch':this.histroy[h].branch,
              'contractRefernce':this.histroy[h].contract_Reference,
              'noofServiceContractYears':this.histroy[h].noofServiceContractYear,
              'startDate':moment(this.histroy[h].start_Date).format("D MMM YYYY"),
              'endDate':moment(this.histroy[h].end_Date).format("D MMM YYYY"),
              'newstartdate':this.histroy[h].start_Date,
              'newenddate':this.histroy[h].end_Date,
              'noOfservice':this.histroy[h].no_Of_Service,
              'serviceRemainderDays':this.histroy[h].remainderday,
              'currentService':this.histroy[h].serviceScheduleDay,
			  'ListserviceDetails': this.histroy[h].Servicedetails,
			  'lastServiceStatusOfContract':'',
              'histroyPr':[],
              'histroyPp':[],
              'ServiceContractExtend':[]

						}
					
						this.ListAllHistroyDetails.push(histroyObject);
					}

    	// 	for(var k =0;k<this.customerDetails.length;k++) {
	    //   		if( this.histroy[0].client_Name == this.customerDetails[k].Id){
	    //   			this.clientName = this.customerDetails[k].Name
	    //   		}
	    //   	}
    		
			// this.serialNumber = this.histroy[0].serial_Number;
			// this.mcLocation = this.histroy[0].mcLocation;
			// this.phoneNumber = this.histroy[0].phone_Number;
			// this.email = this.histroy[0].email;
			// this.make = this.histroy[0].make;
			// this.model = this.histroy[0].model;
			// this.hmrHours = this.histroy[0].hmr;
			// this.technicianName = this.histroy[0].technician_Name;
			// this.lastServiceType = this.histroy[0].last_Service_Type;
			// this.lastServiceHours = this.histroy[0].last_Service_Hours;
			// this.yearOfManufacture = this.histroy[0].year_Of_manufacturer;
			// this.branch = this.histroy[0].branch;
			// this.serviceContractOfferedYear = this.histroy[0].service_Contract_Offered;
			// this.contractReference = this.histroy[0].contract_Reference;
			// this.noofServiceContractYears = this.histroy[0].noofServiceContractYear;
			// this.startDate = this.histroy[0].start_Date;
			// this.endDate = this.histroy[0].end_Date;
			// this.noOfservice = this.histroy[0].no_Of_Service;
			// this.serviceRemainderDays = this.histroy[0].remainderday;
			// this.currentService = this.histroy[0].serviceScheduleDay;
			// for(let i=0;i<this.histroy[0].Servicedetails.length;i++) {
		  //       for(let k=0;k<this.ListAllServcieType.length;k++) {
		  //         if(parseInt(this.histroy[0].Servicedetails[i].service_Type) == this.ListAllServcieType[k]._id) {
		  //           this.histroy[0].Servicedetails[i].service_Type = this.ListAllServcieType[k].servicetype;
		  //         }
		  //       }
		  //   }
			// this.ListserviceDetails = this.histroy[0].Servicedetails
    		let reqObj = {
	          'serialNumber':serialNumber,
	        }
	        return this.http.post('/api/getListAllPostPonedHistroy', reqObj).subscribe(
	        res=>{ 
	           
	          let ppHis = res.json();
	           this.histroyPP = [];
	           this.histroyPr = [];
	           if(ppHis.length>0) {
	            for(var p=0;p<ppHis.length;p++) {
	            	if(ppHis[p].type == 'servicePrepone') {
	            		let pphis = {
		                'serialNumber':ppHis[p].serialNumber,
		                'postPoned_Taken_Date':moment(ppHis[p].postPoned_Taken_Date,).format("D MMM YYYY"),
		                'postPoned_Remainder_Days':ppHis[p].postPoned_Remainder_Days,
		                'schedularNumber':ppHis[p].schedularNumber
		              }
									this.histroyPr.push(pphis);
									for(let pr=0;pr<this.ListAllHistroyDetails.length;pr++) {
										if(this.ListAllHistroyDetails[pr].serialNumber == ppHis[p].serialNumber && this.ListAllHistroyDetails[pr].contractLevel == ppHis[p].contractLevel) {
											this.ListAllHistroyDetails[pr].histroyPr = this.histroyPr;
										}
									} //for loop end here
	            	} else if(ppHis[p].type == 'servicePostpone') {
	            		let pphis = {
		                'serialNumber':ppHis[p].serialNumber,
		                'postPoned_Taken_Date':moment(ppHis[p].postPoned_Taken_Date,).format("D MMM YYYY"),
		                'postPoned_Remainder_Days':ppHis[p].postPoned_Remainder_Days,
		                'schedularNumber':ppHis[p].schedularNumber
		              }
									this.histroyPP.push(pphis);
									for(let pp=0;pp<this.ListAllHistroyDetails.length;pp++) {
										if(this.ListAllHistroyDetails[pp].serialNumber == ppHis[p].serialNumber && this.ListAllHistroyDetails[pp].contractLevel == ppHis[p].contractLevel) {
											this.ListAllHistroyDetails[pp].histroyPp = this.histroyPP;
										}
									} //for loop end here
	            	}
	              
	              
	              
	            }
	          }
	          
	          let reqExtendobj = {
	            'serialNumber':serialNumber,
	          }
	          return this.http.post('/api/getListAllServiceContractExtendHistroy', reqExtendobj).subscribe(
	          res=>{ 
	            let SCExtend = res.json();
	            this.ServiceContractExtend = [];
	            if(SCExtend.length>0) {
	              for(var n=0;n<SCExtend.length;n++) {
	                let SCEobj = {
	                  'serialNumber':SCExtend[n].serialNumber,
	                  'startdate':moment(SCExtend[n].startdate).format("D MMM YYYY"),
	                  'enddate':moment(SCExtend[n].enddate).format("D MMM YYYY"),
	                  'contractExtensionDate':moment(SCExtend[n].contractExtensionDate).format("D MMM YYYY")
	                }
	                this.ServiceContractExtend.push(SCEobj);
	              }
				}
				let statusObj = {
					'pmId':this.ListAllHistroyDetails[0].pmId,
					'serialNumber':this.ListAllHistroyDetails[0].serialNumber
				}
				return this.http.post('/api/serviceStatusChecking_serviceFormAPI', statusObj).subscribe(
				res => {
					 
					let response = res.json();
					if(response.length > 0) {
						if(response[response.length-1].service_Scheduler_Number == this.ListAllHistroyDetails[0].noOfservice && response[response.length-1].status == 1) {
							this.ListAllHistroyDetails[0].lastServiceStatusOfContract = 'completed';
						} else {
							this.ListAllHistroyDetails[0].lastServiceStatusOfContract = 'notcompleted';
						}
					}
					document.body.scrollTop = 0;
					document.documentElement.scrollTop = 0;
	            	this.showAlert();
				})
							
	          },(err)=>{
	          	this.loading=false;
	          })
	          
	        },(err)=>{
	        	this.loading=false;
	        })
	        
	      },(err)=>{
	      	this.loading=false;
	      })
	     
	  }

	viewPostPoneHis(serialNumber, ServiceNum) {
		 
		this.histroyPP = [];
		let reqObj = {
	    	'serialNumber':serialNumber,
	    	'ServiceNum':ServiceNum+1
	    }
	    return this.http.post('/api/getPostPonedHistroy', reqObj).subscribe(
    	res=>{ 
    		 
    		let ppH = res.json();

    		for(var h=0;h<ppH.length;h++){
    			let pphobj = {
    				'serialNumber':ppH[h].serialNumber,
	                'postPoned_Taken_Date':moment(ppH[h].postPoned_Taken_Date,).format("D MMM YYYY"),
	                'postPoned_Remainder_Days':ppH[h].postPoned_Remainder_Days,
	                'schedularNumber':ppH[h].schedularNumber
    			}
    			this.histroyPP.push(pphobj);
    		}
    		this.postPonedHistroy.options = {
	          showButtons: false, // You can hide this in case you want to use custom 
	          color: "#4180ab",
	          widthProsentage:80,
	          header: "PostPone Histroy"
	        };
	        this.postPonedHistroy.show(this.postPonedHistroy.options);
    	})
	}



}



// WEBPACK FOOTER //
// ./client/app/three-time-or-more-postponement-report/three-time-or-more-postponement-report.component.ts